import { useEffect } from 'react'

/**
 * force thairath auth: this page only sends the user to the launch url
 * the previous username/password page is kept in ./index.original.tsx
 */
export const THAIRATH_AUTH_LAUNCH_URL = `${process.env.REACT_APP_MIRROR_API}/api/auth/thairath`

// onSuccess is only used by the original login page, kept so both pages share props
export default function Login(_props: { onSuccess?: (username: string) => void }) {
  useEffect(() => {
    window.location.replace(THAIRATH_AUTH_LAUNCH_URL)
  }, [])

  return null
}
